import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import MoneyInput from "@/components/admin/production/MoneyInput"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import type { CostLineRow as CostLineRowData } from "./types"

interface CostLineRowProps {
  row: CostLineRowData
  index: number
  kinds: string[]
  onChange: (index: number, patch: Partial<CostLineRowData>) => void
  onRemove: (index: number) => void
}

export default function CostLineRow({
  row,
  index,
  kinds,
  onChange,
  onRemove,
}: CostLineRowProps) {
  if (row._destroy) return null

  return (
    <tr className="border-b border-gray-100">
      <td className="py-2 pr-2">
        <Select
          value={row.kind}
          onValueChange={(v) => onChange(index, { kind: v })}
        >
          <SelectTrigger className="h-9 w-40">
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            {kinds.map((k) => (
              <SelectItem key={k} value={k}>
                {k}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </td>
      <td className="py-2 pr-2">
        <Input
          value={row.label}
          onChange={(e) => onChange(index, { label: e.target.value })}
          placeholder="Encre noire 250g"
        />
      </td>
      <td className="py-2 pr-2">
        <MoneyInput
          className="w-32"
          cents={row.amount_cents}
          onChangeCents={(cents) => onChange(index, { amount_cents: cents })}
        />
      </td>
      <td className="py-2 pr-2">
        <Input
          value={row.supplier_name ?? ""}
          onChange={(e) => onChange(index, { supplier_name: e.target.value })}
          placeholder="Fournisseur"
        />
      </td>
      <td className="py-2 pr-2 text-right">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onRemove(index)}
        >
          Retirer
        </Button>
      </td>
    </tr>
  )
}
